import type { RouteObject } from 'react-router-dom';
import { lazyElement } from '../routing/lazyRoute';

const supportRoutes: RouteObject[] = [
  {
    path: '/support/inmate-texting',
    element: lazyElement(() => import('./InmateTexting')),
    handle: {
      documentTitle: 'Inmate Texting Support Inbox',
      crumb: () => ({ label: 'Inmate Texting', to: '/support/inmate-texting' }),
    },
  },
  {
    path: '/support/phone',
    element: lazyElement(() => import('./PhoneSupportInbox')),
    handle: {
      documentTitle: 'Phone Support Inbox',
      crumb: () => ({ label: 'Phone Support Inbox', to: '/support/phone' }),
    },
  },
];

export default supportRoutes;
